/**
 * Flattens a nested object into a single-level object by merging nested properties.
 * Intermediate keys are discarded in the process.
 * @param {Object} obj - The object to flatten
 * @returns {Object} - A flattened object with all nested properties merged at the root level
 */
export default function flattenObject(obj) {
  const flattened = {};
  Object.keys(obj).forEach(key => {
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      Object.assign(flattened, flattenObject(obj[key]));
    } else {
      flattened[key] = obj[key];
    }
  });
  return flattened;
}
